/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { PermissionsState } from '../permissions.slice';
import Membership from '../../models/membership';

export default function toggleMember(state: PermissionsState, action: PayloadAction<Membership>) {
  const { payload: membership } = action;
  const { selectedMembers } = state;
  const index = selectedMembers.findIndex((m) => m.id === membership.id);
  if (state.hasTotalMembersSelected) {
    state.hasTotalMembersSelected = false;
  }

  if (index > -1) {
    selectedMembers.splice(index, 1);
  } else {
    selectedMembers.push(membership);
  }
}
